import { render, staticRenderFns } from "./LocalStorage.vue?vue&type=template&id=bde114de&scoped=true"
import script from "./LocalStorage.vue?vue&type=script&lang=js"
export * from "./LocalStorage.vue?vue&type=script&lang=js"
import style0 from "./LocalStorage.vue?vue&type=style&index=0&id=bde114de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde114de",
  null
  
)

export default component.exports